<div *ngIf="loading" class="loading-screen-wrapper visible h-100" #loadingScreen>
  <div class="loading-screen-icon text-center">
    <img src="/assets/animated-logo.svg" alt="ZWS logo" class="mb-3" style="width: 25vw;">
  </div>
</div>